import React from 'react'
import Header from './Header'
import PlainLink from './PlainLink'

export default function GuestHeader(props) {
  const { loginPath, ...otherProps } = props
  return (
    <Header {...otherProps} authLink={<PlainLink href={loginPath}>Log in</PlainLink>} />
  )
}